// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#ffb601"};